module.exports = __webpack_public_path__ + "static/media/RAMP-BUSD.c96bd5bd.svg";